import React, { useState } from "react";
import FileUpload from "../../../util/FileUpload";
import AlertMessage from "../../../partials/alertMessage";

const NewNoteCategory = ({ onSubmit, onCancel }) => {
	const [image, setImage] = useState(null);
	const [message, setMessage] = useState(null);
	const nameRef = React.createRef();

	return (
		<>
			<form
				onSubmit={_ => {
					_.preventDefault();
					const { value } = nameRef.current;
					if (value) {
						setMessage(null);
						onSubmit({ name: value, image });
						nameRef.current.value = "";
					} else {
						setMessage("Name field is required!");
					}
				}}
				method="post"
			>
				<AlertMessage message={message} failed={true} />
				<div className="form-group">
					<label htmlFor="name-note-category">Activity Name</label>
					<input
						type="text"
						ref={nameRef}
						className="form-control input-height"
						id="name-note-category"
						placeholder="Enter name"
					/>
				</div>
				<div className="form-group">
					<FileUpload
						title="Select Icon Image"
						onData={item => setImage(item.path)}
					/>
				</div>
				<div className="text-center m-b-20 m-t-20">
					<button
						type="button"
						onClick={onCancel}
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default"
					>
						<i className="material-icons text-danger">cancel</i>{" "}
						Cancel
					</button>

					<button
						type="submit"
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 btn-circle btn-success"
					>
						Submit <i className="material-icons">arrow_right_alt</i>
					</button>
				</div>
			</form>
		</>
	);
};

export default NewNoteCategory;
